import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Select } from '~/components/blocks';
import { patientPageInfoState } from '~/state/patient/atoms';

import { usePharmacistOptions } from './use-pharmacist-options';

const Root = styled(Select)(({ theme }) =>
  css({
    fontWeight: theme.fontWeights.default,
    fontSize: theme.fontSizes.s,
    padding: `calc(${theme.space.s} + ${theme.space.xs}) ${theme.space.l} calc(${theme.space.s} + ${theme.space.xs}) ${theme.space.m}`,
    width: 'auto',
  }),
);

export const SelectPharmacist = () => {
  const { loading, options } = usePharmacistOptions();
  const setState = useSetAtom(patientPageInfoState);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const practitionerId = e.currentTarget.value;
      setState((_state) => ({
        ..._state,
        practitionerId: practitionerId || null,
        page: 1,
      }));
    },
    [setState],
  );

  return (
    <Root fill disabled={loading} onChange={handleChange}>
      <option value="">送信者</option>
      {options.map(({ label, value }, idx) => (
        <option key={idx} value={value}>
          {label}
        </option>
      ))}
    </Root>
  );
};
